<template lang='pug'>
.mainWrapper-innerContent
  .mainWrapper-leftContent.mainWrapper-leftContent--fullWidth
    BreadCrumb(:breadcrumbList='breadcrumbs' normal)
    TableBlock(
      :type='type'
      :displayLayoutOption='true'
      :params='config[type].params'
      :headers='config[type].headers'
      :staticData='data.categoryArticles'
      :sectionText='config[type].sectionText'
      :langInRoute='config[type].langInRoute'
      :displayFilter='config[type].displayFilter'
      :displaySort='config[type].displaySort'
      :noArticleText='config[type].noArticleText'
      :displayNoArticleOption='config[type].displayNoArticleOption'
    )
</template>
<script>
import BreadCrumb from '@/components/modules/breadcrumb/breadcrumb.vue'
import TableBlock from '@/components/table/table_block.vue'
import { getCategoryNameById } from '@/plugins/tool.js'

export default {
  components: {
    TableBlock,
    BreadCrumb
  },
  props: {
    data: Object,
    breadcrumbList: Array
  },
  data() {
    let urlParams = this.$route.query
    return {
      info: {},
      type: urlParams.type,
      breadcrumbs: JSON.parse(JSON.stringify(this.breadcrumbList)),
      config: {
        "latestArticlesByCategory": {
          "sectionText": getCategoryNameById(urlParams.categoryId, this.$store.state.lang),
          "params": {
            "categoryId": urlParams.categoryId,
            "size": 12,
            "sort": {
              "updatedAt": {
                "dir": "desc",
                "default": true
              } 
            },
            "page": 0
          },
          "langInRoute": true,
          "headers": {}
        },
        "latestArticles": {
          "sectionText": this.data.sidemenu.pages.latest,
          "params": {
            "size": 12,
            "sort": {
              "updatedAt": {
                "dir": "desc",
                "default": true
              }
            },
            "page": 0
          },
          "langInRoute": true,
          "headers": {}
        },
        "verified": {
          "sectionText": this.data.sidemenu.pages.verified,
          "params": {
            "size": 12,
            "sort": {
              "updatedAt": {
                "dir": "desc",
                "default": true
              }
            },
            "page": 0
          },
          "langInRoute": true,
          "headers": {}
        },
        "partnerVerified": {
          "sectionText": this.data.sidemenu.pages.verified,
          "params": {
            "size": 12,
            "sort": {
              "updatedAt": {
                "dir": "desc",
                "default": true
              }
            },
            "page": 0
          },
          "langInRoute": false,
          "headers": {
            "X-Line-Biz-Session": localStorage.getItem(this.$store.state.storageKeys.token)
          }
        },
        "followingArticles": {
          "sectionText": this.data.sidemenu.pages.follow,
          "params": {
            "size": 12,
            "sort": {
              "tag.id": {
                "dir": "desc",
                "default": true
              },
              "updatedAt": {
                "dir": "desc",
                "default": true
              }
            },
            "page": 0
          },
          "langInRoute": false,
          "headers": {
            "Authorization": "Bearer " + localStorage.getItem(this.$store.state.storageKeys.token)
          },
          "noArticleText": "目前沒有關注中的話題",
          "displayNoArticleOption": false,
          "displayFilter": false
        },
        "partnerFollowingArticles": {
          "sectionText": this.data.sidemenu.pages.follow,
          "params": {
            "size": 12,
            "sort": {
              "article.tag.id": {
                "dir": "desc",
                "default": true
              },
              "article.updatedAt": {
                "dir": "desc",
                "default": true
              }
            },
            "page": 0
          },
          "langInRoute": false,
          "headers": {
            "X-Line-Biz-Session": localStorage.getItem(this.$store.state.storageKeys.token)
          },
          "noArticleText": "目前沒有關注中的話題",
          "displayNoArticleOption": false,
          "displayFilter": false
        },
        "searchArticles": {
          "sectionText": this.data.searchArticles.title,
          "params": {
            "size": 12,
            "sort": {
              "updatedAt": {
                "dir": "desc",
                "default": true
              }
            },
            "page": 0,
            "keyword": encodeURIComponent(urlParams.keyword)
          },
          "langInRoute": true,
          "noArticleText": "查無資料，請嘗試其他關鍵字或篩選條件。",
          "displayNoArticleOption": false
        }
      }
    }
  },
  created() {
    var text = this.config[this.type].sectionText
    switch (this.type) {
      case 'latestArticlesByCategory':
        text += '話題'
        break;
    }
    var link = {}
    link.path = '/category'
    link.query = {}
    link.query.type = this.type

    if (this.config[this.type].params.categoryId)
      link.query.categoryId = this.config[this.type].params.categoryId

    this.breadcrumbs.push({
      text:  text,
      link: link
    })
  }
}
</script>
